import { en } from './en';
import { de } from './de';

// Translation keys and their English/German translations
export const translations = {
    en,
    de
} as const;

// Type for all translation keys
export type TranslationKey = keyof typeof translations.en;
